module.exports = __webpack_public_path__ + "img/Courier-4.73ba4cbc.png";